export const HOME='/';
export const EXPERT='/experts';
export const BROWSE ='/browse';
export const Data = '/admin/subscriber/data';
export const SIGN_UP = '/signup';
export const SIGN_IN = '/signin';